<template>
    <div style="border: 2px solid;color:#00467f">
        <card>
            <!--<h5 class="card-category"></h5>-->
            <h4 class="card-title" style="color:#00467f"><strong>LEGENDA</strong></h4>
            <!--<p class="card-text">With supporting text below as a natural lead-in to additional content.</p>-->
            <div class="row">
                <div class="col" style="text-align:left"><img src="@/assets/img/green.png" style="width:20px; margin-left: 15px;margin-right:15px;margin-bottom:5px"><i>COMPLETATO</i></div>
                <div class="col" style="text-align:left"><img src="@/assets/img/yellow.png" style="width:20px;margin-left: 5px;margin-right:15px;margin-bottom:5px"><i>COMPILA</i></div>
            </div>
            <div class="row">
                <div class="col" style="text-align:left"><img src="@/assets/img/blue.png" style="width:20px;margin-left: 15px;margin-right:15px;margin-bottom:5px"><i>ATTENDI</i></div>
                <div class="col" style="text-align:left"><img src="@/assets/img/red.png" style="width:20px;margin-left: 5px;margin-right:15px;margin-bottom:5px"><i>FALLITO</i></div>
            </div>
        </card>
    </div>
</template>

<script>
export default {
  name:"legenda",
  props: {
    
  },
  methods:{
   
  }
}
</script>
<style>
</style>
